import { render, staticRenderFns } from "./td_build.vue?vue&type=template&id=e5fa1358&scoped=true"
import script from "./td_build.vue?vue&type=script&lang=js"
export * from "./td_build.vue?vue&type=script&lang=js"
import style0 from "./td_build.vue?vue&type=style&index=0&id=e5fa1358&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5fa1358",
  null
  
)

export default component.exports